/* ═══════════════════════════════════════════════════════════════
   Timesheets rebuild — CSV export (preserved from the old page).
   ═══════════════════════════════════════════════════════════════ */

import type { HourEntry, Project, ActivityCode } from '../../../shared/types';
import type { ProjectRow } from './types';
import { DAY_NAMES } from './dateUtils';
import { getOverheadHours, getProjectHours } from './computeGrid';

export function exportTimesheetCSV(args: {
  weekStart: string;
  weekDates: string[];
  overheadNames: string[];
  projectRows: ProjectRow[];
  projects: Project[];
  activityCodes: ActivityCode[];
  entries: HourEntry[];
}) {
  const { weekStart, weekDates, overheadNames, projectRows, projects, activityCodes, entries } =
    args;
  const rows: string[] = [];
  rows.push(['Description', 'Billing Code', ...DAY_NAMES, 'Total'].join(','));

  for (const cat of overheadNames) {
    const vals = weekDates.map((ds) => getOverheadHours(entries, cat, ds) || '');
    const total = weekDates.reduce((s, ds) => s + getOverheadHours(entries, cat, ds), 0);
    rows.push([`"${cat}"`, '"Non-billable"', ...vals, total].join(','));
  }

  for (const row of projectRows) {
    const proj = projects.find((p) => p.id === row.projectId);
    const code = activityCodes.find((c) => c.id === row.activityCodeId);
    const vals = weekDates.map(
      (ds) => getProjectHours(entries, row.projectId, row.activityCodeId, ds) || ''
    );
    const total = weekDates.reduce(
      (s, ds) => s + getProjectHours(entries, row.projectId, row.activityCodeId, ds),
      0
    );
    rows.push(
      [
        `"${proj?.projectNumber || ''} ${proj?.name || ''}"`,
        `"${code?.name || ''}"`,
        ...vals,
        total,
      ].join(',')
    );
  }

  const blob = new Blob([rows.join('\n')], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `timesheet-${weekStart}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
